import { api } from './api';
import type { NewsRow } from './types';

/** أخبار المنصة المنشورة — بلا دخول ولا رأسية مؤسسة (تقرؤها الصفحة الأولى و/news) */
export function publicNewsQuery() {
  return {
    queryKey: ['public', 'news'] as const,
    queryFn: () => api.get<NewsRow[]>('/public/news', { institutionId: null, anonymous: true }),
    staleTime: 5 * 60_000,
  };
}
